<template>
  <div class="bases-list">
    <ul class="bases-list-header">
      <li>年份</li>
      <li>专业</li>
      <li>学位门类</li>
      <li>招生人数</li>
    </ul>
    <div class="base-item" v-for="(base, index) in schoolData" :key="index">
      <p>{{ base.year }}</p>
      <p>{{ base.spnameNew || '-' }}</p>
      <p>{{ base.subjectName || '-' }}</p>
      <p>{{ base.num || '-' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orgSchoolList',
  props: ['schoolData'],
};
</script>

<style scoped lang="less">
.bases-list {
  .bases-list-header {
    display: flex;
    list-style: none;
    height: 40px;
    line-height: 40px;
    background-color: #f9fafb;
    border-bottom: 1px solid #eae9e9;
    margin-top: 12px;

    li {
      box-sizing: border-box;
      padding: 0 10px;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      border-right: 1px solid #eeeeee;
      text-align: center;

      &:nth-of-type(1) {
        width: 150px;
      }
      &:nth-of-type(2) {
        width: 430px;
      }
      &:nth-of-type(3) {
        width: 100px;
      }
      &:nth-of-type(4) {
        width: 280px;
      }
    }
  }

  .base-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    color: #333333;

    > p {
      box-sizing: border-box;
      padding: 10px;
      color: #333333;
      overflow: hidden;
      font-size: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;

      &:nth-of-type(1) {
        width: 150px;
      }
      &:nth-of-type(2) {
        width: 430px;
      }
      &:nth-of-type(3) {
        width: 100px;
        text-align: center;
      }
      &:nth-of-type(4) {
        width: 280px;
        text-align: center;
      }
    }
  }
}
</style>
